import Image from 'next/image'

import { Custodian } from '@/types/enums/custodian'

// Mapping from API custodian IDs to enum values
export const CUSTODIAN_ID_TO_ENUM: Record<string, Custodian> = {
  // API IDs
  cust_fidelity: Custodian.Fidelity,
  cust_schwab: Custodian.Schwab,
  cust_pershing: Custodian.Pershing,
  cust_rbc: Custodian.RBC,
  cust_lpl: Custodian.LPL,
  cust_goldman: Custodian.Goldman,
  cust_vision: Custodian.Vision,
  // Display names (in case the API returns the display name instead)
  Fidelity: Custodian.Fidelity,
  Schwab: Custodian.Schwab,
  Pershing: Custodian.Pershing,
  RBC: Custodian.RBC,
  LPL: Custodian.LPL,
  'Goldman Sachs': Custodian.Goldman,
  'Vision Financial Markets': Custodian.Vision,
  // Lowercase variants
  fidelity: Custodian.Fidelity,
  schwab: Custodian.Schwab,
  pershing: Custodian.Pershing,
  rbc: Custodian.RBC,
  lpl: Custodian.LPL,
  'goldman sachs': Custodian.Goldman,
  'vision financial markets': Custodian.Vision,
}

export const CUSTODIAN_CONFIG = {
  [Custodian.Fidelity]: {
    label: 'Fidelity G-number',
    placeholder: 'Enter Fidelity advisor code',
    displayName: 'Fidelity',
    icon: (
      <Image
        src="/fidelity_xl.png"
        alt="Fidelity"
        width={20}
        height={20}
        className="rounded"
      />
    ),
  },
  [Custodian.Schwab]: {
    label: 'Schwab Master ID',
    placeholder: 'Enter Schwab advisor code',
    displayName: 'Schwab',
    icon: (
      <Image
        src="/charles_schwab_xl.png"
        alt="Schwab"
        width={20}
        height={20}
        className="rounded"
      />
    ),
  },
  [Custodian.Pershing]: {
    label: 'Pershing Investment Professional (IP) ID',
    placeholder: 'Enter Pershing advisor code',
    displayName: 'Pershing',
    icon: (
      <Image
        src="/pershing.svg"
        alt="Pershing"
        width={20}
        height={20}
        className="rounded"
      />
    ),
  },
  [Custodian.LPL]: {
    label: 'LPL Financial Advisor ID',
    placeholder: 'Enter LPL Financial advisor code',
    displayName: 'LPL',
    icon: (
      <div className="w-5 h-5 bg-blue-600 text-white text-xs font-bold rounded flex items-center justify-center">
        L
      </div>
    ),
  },
  [Custodian.RBC]: {
    label: 'RBC Advisor ID',
    placeholder: 'Enter RBC advisor code',
    displayName: 'RBC',
    icon: (
      <div className="w-5 h-5 bg-blue-800 text-white text-xs font-bold rounded flex items-center justify-center">
        R
      </div>
    ),
  },
  [Custodian.Goldman]: {
    label: 'Goldman Sachs Advisor ID',
    placeholder: 'Enter Goldman Sachs advisor code',
    displayName: 'Goldman Sachs',
    icon: (
      <div className="w-5 h-5 bg-blue-800 text-white text-xs font-bold rounded flex items-center justify-center">
        G
      </div>
    ),
  },
  [Custodian.Vision]: {
    label: 'Vision Financial Markets Advisor ID',
    placeholder: 'Enter Vision Financial Markets advisor code',
    displayName: 'Vision Financial Markets',
    icon: (
      <div className="w-5 h-5 bg-blue-800 text-white text-xs font-bold rounded flex items-center justify-center">
        V
      </div>
    ),
  },
}

// Mapping from API custodian IDs to display names
export const getCustodianDisplayName = (custodianId: string): string => {
  const custodianEnum = CUSTODIAN_ID_TO_ENUM[custodianId]
  return custodianEnum
    ? CUSTODIAN_CONFIG[custodianEnum].displayName
    : custodianId
}
